import React from 'react';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import EntitiesErrorMessages from '@/components/errors/EntitiesErrorMessages';
import fetch from '../hooks/fetch';
import CollectionPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/CollectionPanelContainer';
import CollectionName from './CollectionName';
import CollectionDescription from './CollectionDescription';
import CollectionDatasetsPanelFull from '../datasets/containers/CollectionDatasetsPanelFull';
import CollectionImage from './CollectionImage';

const CollectionPanelFull = ({
  canRead,
  category,
  code,
  exists,
  fetchData,
  isDirty,
  isEditing,
  isNew,
  name,
  onChange,
  readErrors,
  readStatus,
  saveErrors,
  updateProperties,
  url,
}) => {
  fetch.useFetchCollection(fetchData, category, code, readStatus, isNew);
  return (
    <CollectionPanelContainer
      canRead={canRead}
      exists={exists}
      isDirty={isDirty}
      isNew={isNew}
      name={name}
      onChange={onChange}
      readErrors={readErrors}
      readStatus={[readStatus]}
      url={url}
    >
      <div className="aridhia-collection-panel-full">
        <EntitiesErrorMessages
          category={category}
          code={code}
          entity="collection"
          errors={saveErrors}
          onDismiss={(errors) => updateProperties(category, code, { saveErrors: errors })}
        />
        <Grid>
          <Grid.Row columns="equal">
            <Grid.Column {...(!isEditing && { width: 8 })}>
              <CollectionName code={code} category={category} />
            </Grid.Column>
          </Grid.Row>
          <div className="aridhia-collection-detail">
            <CollectionImage code={code} category={category} />
            <CollectionDescription code={code} category={category} />
          </div>
          {!isEditing
            && (
            <Grid.Row className="pt-0">
              <Grid.Column>
                <CollectionDatasetsPanelFull category={category} code={code} />
              </Grid.Column>
            </Grid.Row>
            )}
        </Grid>
      </div>
    </CollectionPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionPanelFull);
